import React from 'react';
import { ButtonProps } from '../../../../components/menus/buttons/types';
import EditorSwap from '@wix/da-ds/pkg/Icons/24x24/EditorSwap';
import { useTranslation } from 'react-i18next';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import EditorLink from '@wix/da-ds/pkg/Icons/24x24/EditorLink';
import EditorImage from '@wix/da-ds/pkg/Icons/24x24/EditorImage';
import { popperDropdownConfig } from '../../constants';
import EditorIconButtonWithContextMenu from '../../../../components/menus/_partials/EditorIconButtonWithContextMenu';

const Convert: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');

  return (
    <EditorIconButtonWithContextMenu
      featureId="node:deviation:convert"
      tooltipText={t('ext.deviation.toolbar.convert')}
      aria-label={t('ext.deviation.toolbar.convert')}
      tooltipHoverDelay={TOOLTIP_HOVER_DELAY}
      icon={EditorSwap}
      items={[
        {
          featureId: 'node:deviation:convertToLink',
          label: t('ext.deviation.toolbar.convert.toLink'),
          icon: <EditorLink />,
          onClick: () => {
            editor.chain().focus().daDeviationToLink().run();
          },
        },
        {
          featureId: 'node:deviation:convertToThumb',
          label: t('ext.deviation.toolbar.convert.toThumb'),
          icon: <EditorImage />,
          onClick: () => {
            editor.chain().focus().daDeviationConvertToThumb().run();
          },
        },
      ]}
      popperManagerProps={popperDropdownConfig}
    ></EditorIconButtonWithContextMenu>
  );
};
Convert.displayName = 'Convert';

export default Convert;
